import { clampTo, extractImageFrames } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const klingConfigs: Record<string, WavespeedModelConfig> = {
    'kling-v3-turbo': {
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-v3-turbo-std/text-to-video
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-v3-turbo-std/image-to-video
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-v3-turbo-pro/text-to-video
        // https://wavespeed.ai/zh-CN/models/kwaivgi/kling-v3-turbo-pro/image-to-video
        apiPath: (params) => {
            const { frameMode, quality } = params;
            const tier = quality === '1080p' ? 'pro' : 'std';
            const mode = frameMode === 'first' ? 'image-to-video' : 'text-to-video';
            return `/kwaivgi/kling-v3-turbo-${tier}/${mode}`;
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: prompt.slice(0, 2500),
                    duration: String(clampTo(duration || 5, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5)),
                    // 首帧 URL
                    image: firstImage,
                    // system
                    multi_prompt: undefined,
                };
            }
            // 文生视频模式
            return {
                prompt: prompt.slice(0, 2500),
                aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '1:1'] as const, '16:9'),
                duration: String(clampTo(duration || 5, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5)),
                // system
                multi_prompt: undefined,
            };
        },
    },
};